import { render, staticRenderFns } from "./NavbarAdmin.vue?vue&type=template&id=e79a81d2"
import script from "./NavbarAdmin.vue?vue&type=script&lang=js"
export * from "./NavbarAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports